import { useEffect, useState } from 'react'
import type { TrainingDocumentDto } from './trainingDocument'
import { fetchTrainingDocuments } from './trainingDocumentsApi'

export function useTrainingDocuments() {
  const [documents, setDocuments] = useState<TrainingDocumentDto[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      setLoading(true)
      setError(null)
      try {
        const list = await fetchTrainingDocuments()
        if (cancelled) return
        setDocuments(list)
      } catch (err) {
        if (cancelled) return
        setDocuments([])
        setError(err instanceof Error ? err.message : 'Unable to load training documents.')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    void load()
    return () => {
      cancelled = true
    }
  }, [])

  return { documents, loading, error }
}
